import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'

import React from 'react'
import { LoadingCard } from '../LoadingCard/LoadingCard'

interface LoadCandidateScreeningTemplatesModalProps {
  loading: boolean
  loadTemplateModal: boolean
  setLoadTemplateModal: (open: boolean) => void
  screeningTemplates: any[]
  loadSelectedTemplate: (templateId: string) => void
  selectedScreeningTemplateId: string | null
  setSelectedScreeningTemplateId: (id: string | null) => void
}

export const LoadCandidateScreeningTemplatesModal: React.FC<
  LoadCandidateScreeningTemplatesModalProps
> = ({
  loading,
  loadTemplateModal,
  setLoadTemplateModal,
  screeningTemplates,
  loadSelectedTemplate,
  selectedScreeningTemplateId,
  setSelectedScreeningTemplateId,
}) => {
  return (
    <Dialog
      open={loadTemplateModal}
      onClose={() => setLoadTemplateModal(false)}
      fullWidth
      maxWidth='xs'
    >
      <DialogTitle>Load Constraint Template</DialogTitle>
      <Divider />
      <DialogContent>
        {loading ? (
          <LoadingCard />
        ) : (
          <FormControl variant='standard' fullWidth>
            <Select
              placeholder='Search constraint to load'
              labelId='load-screen-constraint-modal-label'
              id='load-screen-constraint-modal'
              value={selectedScreeningTemplateId || ''}
              onChange={(event: SelectChangeEvent<string>) => {
                setSelectedScreeningTemplateId(event.target.value)
              }}
            >
              {screeningTemplates?.length ? (
                screeningTemplates?.map((template) => (
                  <MenuItem key={template.shortName} value={template.shortName}>
                    {template.longName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value=''>
                  <em>No constraint template available</em>
                </MenuItem>
              )}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          variant='contained'
          disabled={!selectedScreeningTemplateId}
          size='small'
          onClick={() =>
            loadSelectedTemplate(selectedScreeningTemplateId || '')
          }
        >
          Load
        </Button>
        <Button
          variant='outlined'
          onClick={() => setLoadTemplateModal(false)}
          size='small'
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}
